import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonCheckbox from '../components/CommonCheckbox';
/**
import CommonRadio from '../components/CommonRadio';
*/
import CommonButton from '../components/CommonButton';

class SearchEB02DataCourse extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { academy_id, course_eb_01_name, official_course_code, course_checked, budget_within_criteria, hdc_status, authorized_status, course_status } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">              
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{academy_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={academy_id}
                                        option={{source: 'db', data: Masterbase?.academy}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                        disabled={!['0','1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col>    
                            <Col md={6}>
                                <div className="mt-2">
                                    <InputGroup className="mb-3">
                                        <CommonCheckbox
                                            element="Searchs"
                                            input={Searchs}
                                            checkbox={InputGroups.Checkbox.search_eec_hdc}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </InputGroup>
                                </div>
                            </Col>        
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{official_course_code.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={official_course_code}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>   
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{course_eb_01_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={course_eb_01_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                       
                        </Row>
                        <Row>                            
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{hdc_status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={hdc_status}
                                        option={{source: 'options', section: 'status', item: 'eb02_course_eec_hdc'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{authorized_status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={authorized_status}
                                        option={{source: 'options', section: 'status', item: 'eb02_course_authorize'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{course_status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={course_status}
                                        option={{source: 'options', section: 'status', item: 'eb02_course_status'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                            
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>                    
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchEB02DataCourse;